import { RocketOutlined } from '@ant-design/icons';
import { Button, ButtonProps, Tooltip } from 'antd';
import { useRouter } from 'next/router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCurrentUserStore } from '../../store/RootStoreContext';
import { isAdmin } from '../../utils/accountHelper';

const SubscriptionBadge = ({
    children,
    isShow,
    buttonProps,
    buttonStyle = { top: '-10px', right: '-10px', color: 'white' }
}: {
    children: React.ReactNode;
    isShow: boolean;
    buttonProps?: ButtonProps;
    buttonStyle?: { top?: string; right?: string; color?: ButtonProps['color'] };
}) => {
    const { push } = useRouter();
    const { t } = useTranslation('subscription');
    const { role } = useCurrentUserStore();
    const isCurrentUserAdmin = isAdmin(role);
    const subButtonHandle = () => {
        if (isCurrentUserAdmin) push('/admin/subscription');
    };
    if (!isShow) return <>{children}</>;
    return (
        <Tooltip title={t('badgeTitle')}>
            <>
                <div style={{ position: 'relative' }} className="full-width full-height">
                    <div
                        style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'transparent',
                            zIndex: '1031'
                        }}
                    ></div>
                    <Button
                        type="primary"
                        shape="circle"
                        icon={<RocketOutlined />}
                        onClick={subButtonHandle}
                        style={{
                            zIndex: '1032',
                            position: 'absolute',
                            top: buttonStyle.top ?? '-10px',
                            right: buttonStyle.right ?? '-10px',
                            color: buttonStyle.color
                        }}
                        {...buttonProps}
                    />
                    {children}
                </div>
            </>
        </Tooltip>
    );
};

export default SubscriptionBadge;
